import React from 'react';
import './styles.scss';
import Chart from '../../../components/organisms/chart';
import { RouteSalesData } from './hooks';

interface Props {
    routeSales: RouteSalesData[];
    isLoading: boolean;
    currentView: number;
    setCurrentView: React.Dispatch<number>;
    amount: number[]
}

function RenderRoutesOverview(props: Props) {
  const {
    routeSales, isLoading, currentView, setCurrentView, amount,
  } = props;

  return (
    <div className="mb-4">
      <Chart.Overview.Default
        title="Routes Overview"
        topContent={routeSales.map((route) => {
          if (route?.total?.name) return <div className="fz-14">{route.total.name}</div>;
          return <div>-</div>;
        })}
        items={[
          { label: 'Sale', bgColor: 'rgb(162, 140, 245)', amount },
        ]}
        currentView={currentView}
        setCurrentView={setCurrentView}
        labels={[routeSales[0]?.total?.dateKey ?? '']}
        isData={!!routeSales.length}
        isLoading={isLoading}
      />
    </div>
  );
}

export default React.memo(RenderRoutesOverview);
